import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { heroWhyDescriptionWrapperStyle } from "styles/home_page/why";
import { heroWhyDescriptionSubtitleStyle } from "styles/home_page/why";
import { heroWhyDescriptionParagraphStyle } from "styles/home_page/why";
import { heroWhyAnimationGridStyle } from "styles/home_page/why";

interface Props { 
    subtitle: string,
    paragraph: string,
}

export default function MdDescription({subtitle, paragraph}: Props) {
    return(
        <Grid item xs={2.75} sx={[heroWhyAnimationGridStyle, heroWhyDescriptionWrapperStyle]}>
            <Stack alignItems="center" justifyContent="center">
                <Typography variant="body1" sx={heroWhyDescriptionSubtitleStyle} textAlign="center">
                    {subtitle}
                </Typography>
                <Typography variant="body1" sx={heroWhyDescriptionParagraphStyle} textAlign="justify">
                    {paragraph}
                </Typography>
            </Stack>
        </Grid>
    )
}
